import { useMutation } from "@tanstack/react-query";
import { authClient } from "@/lib/auth-client";

interface CompletePasswordResetVariables {
  newPassword: string;
  token: string;
}

export function useCompletePasswordReset() {
  return useMutation<any, Error, CompletePasswordResetVariables>({
    mutationFn: async ({ newPassword, token }) => {
      const { data, error } = await authClient.resetPassword({
        newPassword,
        token,
      });

      if (error) {
        throw new Error(error.message || "Failed to reset password");
      }

      return data;
    },
  });
}
